import { render, staticRenderFns } from "./pcbfile.vue?vue&type=template&id=d642d3f0&scoped=true"
import script from "./pcbfile.vue?vue&type=script&lang=js"
export * from "./pcbfile.vue?vue&type=script&lang=js"
import style0 from "./pcbfile.vue?vue&type=style&index=0&id=d642d3f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d642d3f0",
  null
  
)

export default component.exports